import { useState } from 'react';

interface ValidationSchema {
  validate(val: any): boolean;
  errorMessage?: string;
}

export interface UseValidation {
  validate: (val?: any) => boolean;
  hasError: boolean;
  errorMessage: string;
}

function useValidation(schema: ValidationSchema) {
  const [hasError, setHasError] = useState(false);

  const validate = (val: any): boolean => {
    const isValid = schema.validate(val);
    setHasError(!isValid);
    return isValid;
  };

  const errorMessage = schema.errorMessage || '';

  return {
    validate,
    hasError,
    setHasError,
    errorMessage: hasError ? errorMessage : '',
  };
}

export default useValidation;
